<template>
  <div>
    <section class="main" v-if="ProductData.Product != null">
      <div class="container">
        <div class="img-box">
          <img :src="ProductData.SiteUrl + ProductData.Product.Image" alt="" />
        </div>
        <div class="box">
          <!-- 0517 新增 title-box div -->
          <div class="title-box">
            <h1>{{ ProductData.Product.Name }}</h1>

            <div style="display: flex">
              <img v-if="ProductData.Product.IconMRT" src="img/icon_MRT.png" alt=""
                style="margin-right: 5px; width: 32px; height: 32px" />
              <img v-if="ProductData.Product.IconLightRail" src="img/icon_LightRail.png" alt=""
                style="margin-right: 5px; width: 32px; height: 32px" />
              <img v-if="ProductData.Product.IconBus" src="img/icon_Bus.png" alt=""
                style="margin-right: 5px; width: 32px; height: 32px" />
              <img v-if="ProductData.Product.IconBicycle" src="img/icon_Bicycle.png" alt=""
                style="margin-right: 5px; width: 32px; height: 32px" />
              <img v-if="ProductData.Product.IconFerry" src="img/icon_Ferry.png" alt=""
                style="margin-right: 5px; width: 32px; height: 32px" />
            </div>
            <div class="price">
              <p v-if="ProductData.Product.OriginalPrice > 0">
                NTD{{ ProductData.Product.OriginalPrice }}
              </p>
              <p v-if="ProductData.Product.OriginalPrice == 0"></p>
              <p>NTD</p>
              <p>{{ ProductData.Product.Price }}</p>
            </div>
            <!-- 0607 新增 hr -->
            <hr />
            <!-- 0607 新增 ul -->
            <ul class="main-box">
              <li>
                <div>{{ $t("類型") }}</div>
                <div>QR Code</div>
              </li>
              <li>
                <div>{{ $t("品項") }}</div>
                <div>{{ ProductData.Product.Time }}{{ $t("小時") }}</div>
              </li>
              <hr />
              <li>
                <div>{{ $t("數量") }}</div>
                <div class="count">
                  <div class="minus" v-on:click="onReduceBuyCount">－</div>
                  <div class="num">{{ BuyCount }}</div>
                  <div class="add" v-on:click="onAddBuyCount">＋</div>
                </div>
              </li>
              <hr />
              <li>
                <div>{{ $t("優惠券代碼") }}</div>
                <button style="padding: 1px 10px" @click="checkCoupon()">
                  <!-- <img src="img/icon-tick.png" alt="" /> -->
                  {{ $t("套用優惠券") }}
                </button>
              </li>
              <div>
                <input type="text" class="form-control" id="couponCode" name="couponCode" :placeholder="$t('請輸入優惠券碼')"
                  v-model="CouponCode" maxlength="20" />
              </div>
              <hr />
              <li class="total" v-if="!UseCoupon">
                <div>{{ $t("總計") }}</div>
                <div>
                  NTD <span>{{ ProductData.Product.Price * BuyCount }}</span>
                </div>
              </li>
              <li class="total" v-if="UseCoupon">
                <div>{{ $t("總計(套用優惠券)") }}</div>
                <div>
                  NTD
                  <span>{{
                    CouponPrice + ProductData.Product.Price * (BuyCount - 1)
                  }}</span>
                </div>
              </li>
            </ul>
            <hr />
            <!-- 0608 新增 -->
            <div>
              <h1>{{ $t("付款方式") }}</h1>
              <div class="form-group form-check-box">
                <div class="form-check form-check-inline"
                  v-if="local != 'jp' && !ProductData.Product.OnlyCoupon">
                  <input id="payTypeOfiPASSMONEY" class="form-check-input" type="radio" name="payType" value="3"
                    v-model="PayType" />
                  <label class="form-check-label" for="payTypeOfiPASSMONEY">
                    iPASS MONEY
                  </label>
                </div>
                <div class="form-check form-check-inline" v-if="local != 'jp' && !ProductData.Product.OnlyCoupon">
                  <input id="payTypeOfLINEPay" class="form-check-input" type="radio" name="payType" value="1"
                    v-model="PayType" />
                  <label class="form-check-label" for="payTypeOfLINEPay">
                    LINE PAY
                  </label>
                </div>
                <div class="form-check form-check-inline" v-if="!ProductData.Product.OnlyCoupon">
                  <input id="payTypeOfCreditCard" class="form-check-input" type="radio" name="payType" value="0"
                    v-model="PayType" :checked="!ProductData.Product.OnlyCoupon" />
                  <label class="form-check-label" for="payTypeOfCreditCard">
                    {{ $t("線上刷卡") }}
                  </label>
                </div>
              </div>
              <hr />
              <div class="btn-box" v-if="IsLogin">
                <div class="btn-box">
                  <button @click="checkPay">{{ $t("立即購買") }}</button>
                </div>
              </div>
              <div class="btn-box" v-if="!IsLogin">
                <router-link :to="{ name: 'Login' }" tag="button">
                  {{ $t("請先登入") }}
                </router-link>
              </div>
            </div>
          </div>
          <hr />
          <!-- 0517 新增 text-box div -->
          <div class="text-box">
            <!-- 0517 新增 h2 -->
            <h2>{{ $t("方案內容") }}</h2>
            <p class="text" v-html="ProductData.Product.Content"></p>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import CryptoJS from "crypto-js";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    "類型": "類型",
    "品項": "品項",
    "小時": "小時",
    "數量": "數量",
    "總計": "總計",
    "付款方式": "付款方式",
    "線上刷卡": "線上刷卡",
    "立即購買": "立即購買",
    "請先登入": "請先登入",
    "方案內容": "方案內容",
    "請稍候...": "請稍候...",
    "錯誤": "錯誤",
    "訂單建立過程發生錯誤, 請稍後再試一次": "訂單建立過程發生錯誤, 請稍後再試一次",
    "確定": "確定",
    "交易完成": "交易完成",
    "關閉": "關閉",
    "繼續": "繼續",
    "付款完成後請點選「確定」前往訂單頁面確認套票購買狀態": "付款完成後請點選「確定」前往訂單頁面確認套票購買狀態",
    "優惠券代碼": "優惠券代碼",
    "套用優惠券": "套用優惠券",
    "請輸入優惠券碼": "請輸入優惠券碼",
    "總計(套用優惠券)": "總計(套用優惠券)",
  },
  en: {
    "類型": "Type",
    "品項": "Item",
    "小時": "Hour",
    "數量": "Quantity",
    "總計": "Total",
    "付款方式": "Payment",
    "線上刷卡": "Online payment",
    "立即購買": "Buy now",
    "請先登入": "Please log in",
    "方案內容": "Content",
    "請稍候...": "Wait a second",
    "錯誤": "Error",
    "訂單建立過程發生錯誤, 請稍後再試一次": "Error, please try again.",
    "確定": "Confirm",
    "交易完成": "Thank you",
    "關閉": "Close",
    "繼續": "Continue",
    "付款完成後請點選「確定」前往訂單頁面確認套票購買狀態": "After payment, you will be transfered to the order page to confirm pass.",
    "優惠券代碼": "Coupon Code",
    "套用優惠券": "Use Coupon",
    "請輸入優惠券碼": "Please Enter Coupon Code",
    "總計(套用優惠券)": "Total (with coupon applied)",
  },
  jp: {
    "類型": "タイプ",
    "品項": "種類",
    "小時": "時間",
    "數量": "数量",
    "總計": "合計",
    "付款方式": "支払い方法",
    "線上刷卡": "クレジットカード",
    "立即購買": "今すぐ買う",
    "請先登入": "先にログインする",
    "方案內容": "プラン内容",
    "請稍候...": "しばらくお待ちください",
    "錯誤": "エラー",
    "訂單建立過程發生錯誤, 請稍後再試一次": "購入手続き中にエラーが発生しました,時間をおいてから再度お試しください",
    "確定": "確定",
    "交易完成": "ご注文が完了しました",
    "關閉": "閉じる",
    "繼續": "続ける",
    "付款完成後請點選「確定」前往訂單頁面確認套票購買狀態": "お支払いが完了したら「確認」をクリックして注文画面に移動し、フリーパスの購入状況を確認してください",
    "優惠券代碼": "クーポンコード",
    "套用優惠券": "クーポンを適用",
    "請輸入優惠券碼": "クーポンコードを入力する",
    "總計(套用優惠券)": "合計(クーポンを適用)",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "ProductBuy",
  i18n,
  data() {
    return {
      BuyCount: 1,
      ProductData: {},
      IsLogin: Storage.isKey("ek_login_token"),
      PayType: "0",
      PayUrl: "",
      CouponCode: "",
      UseCoupon: false,
      CouponPrice: 0,
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
      local: "zh_tw",
      IsTester: false,
    };
  },
  watch: {
    PayUrl: (newVal, oldVal) => {
      if (newVal != "") {
        window.open(newVal);
      }
    },
    CouponCode(newValue, oldValue) {
      var rules = new RegExp(/[^A-Z0-9]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.CouponCode = newValue.replace(rules, '');
        })
      }
    },
  },
  created: function () {
    Vue.axios
      .get(
        this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/ProductBuy",
        {
          params: { token: Storage.get("ek_login_token"), PRId: this.$route.params.PRId },
        }
      )
      .then((response) => {
        this.ProductData = response.data;
        this.IsTester = this.ProductData.IsTester;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("package-main");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  updated: function () { },
  methods: {
    onAddBuyCount() {
      if (this.BuyCount + 1 <= this.ProductData.Product.PurchaseLimit) {
        this.BuyCount += 1;
      }
    },
    onReduceBuyCount() {
      if (this.BuyCount - 1 >= 1) {
        this.BuyCount -= 1;
      }
    },
    checkPay() {
      if (this.UseCoupon) {
        this.$swal({
          heightAuto: false,
          icon: "warning",
          title: "請注意!",
          text: "前往付款後優惠券將會立即失效, 是否確定使用此優惠券?",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonText: "確定",
          cancelButtonText: "取消",
        }).then((result) => {
          if (result.isConfirmed) {
            this.gotoPay();
          }
        });
      } else if (!this.UseCoupon && this.CouponCode) {
        this.$swal({
          heightAuto: false,
          title: this.$t("提示"),
          text: this.$t("若要套用優惠券碼, 請點選「套用優惠券」"),
          icon: "info",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
      } else {
        this.gotoPay();
      }
    },
    gotoPay() {
      let that = this;
      // 顯示請稍候
      that.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      // 進入交易環節
      $.ajax({
        url:
          that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/CreateOrder",
        type: "post",
        data: {
          ProductType: 1,
          PRId: that.ProductData.Product.PRId,
          PayType: that.PayType,
          BuyCount: that.BuyCount,
          CouponCode: that.CouponCode,
          platform:
            that.isMobile && typeof cordova != "undefined"
              ? device.platform
              : "Browser",
          token: Storage.get("ek_login_token"),
        },
        dataType: "json",
        async: false,
        error: function () {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("訂單建立過程發生錯誤, 請稍後再試一次"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            if (res.CouponOrder) {
              that.$swal({
                heightAuto: false,
                title: that.$t("交易完成"),
                icon: "success",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
                willClose: function () {
                  // 轉到首頁
                  that.$router.push({
                    name: "OrderInfo",
                    params: { OrderId: res.OrderId },
                  });
                },
              });
            } else {
              if (that.isMobile && typeof cordova != "undefined") {
                if (device.platform == "iOS" || that.PayType == 3) {
                  cordova.InAppBrowser.open(res.PayUrl, "_system");
                } else {
                  cordova.InAppBrowser.open(
                    res.PayUrl,
                    "_blank",
                    "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
                    that.$t("關閉") +
                    ",closebuttoncolor=#ffffff"
                  );
                }
                // 跳出視窗等待付款結果
                that.$swal({
                  heightAuto: false,
                  title: that.$t("繼續"),
                  text: that.$t("付款完成後，將前往訂單頁面確認套票購買狀態"),
                  icon: "success",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                  willClose: function () {
                    // 轉到首頁
                    that.$router.push({
                      name: "OrderInfo",
                      params: { OrderId: res.OrderId },
                    });
                  },
                });
              } else {
                location.href = res.PayUrl;
                //window.open(res.PayUrl, "_blank");
              }
            }
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            if (res.toekn_error) {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                willClose: function () {
                  // 移除登入資訊
                  Storage.remove("ek_login_token");
                  // 回到首頁
                  that.$router.push({
                    name: "Home",
                    params: {},
                  });
                },
              });
            } else {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            }
          }
        },
      });
    },
    checkCoupon() {
      if (this.CouponCode) {
        let that = this;
        $.ajax({
          url:
            that.GLOBAL.apiSrc +
            that.GLOBAL.subDirectory +
            "/Htmlv2/CheckCoupon",
          type: "post",
          data: {
            PRId: that.ProductData.Product.PRId,
            couponCode: that.CouponCode,
            token: Storage.get("ek_login_token"),
          },
          dataType: "json",
          async: false,
          error: function () {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: that.$t("訂單建立過程發生錯誤, 請稍後再試一次"),
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          },
          success: function (res) {
            // 判斷結果
            if (res.ok) {
              that.UseCoupon = true;
              that.CouponPrice = res.CouponPrice;
            } else if (res.error_msg) {
              var error_msg = JSON.parse(res.error_msg);
              if (res.toekn_error) {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  willClose: function () {
                    // 移除登入資訊
                    Storage.remove("ek_login_token");
                    // 回到首頁
                    that.$router.push({
                      name: "Home",
                      params: {},
                    });
                  },
                });
              } else {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            }
          },
        });
      } else {
        this.UseCoupon = false;
        this.CouponPrice = 0;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.count {
  border: solid 1px #ff4f48;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  width: 150px;
  justify-content: space-between;
  float: right;
}

.minus,
.add {
  font-size: 15px;
  color: #fff;
  background-color: #ff4f48;
  line-height: 30px;
  width: 35px;
  text-align: center;
  cursor: pointer;
}

.num {
  font-size: 18px;
  text-align: center;
  color: #000;
  display: block;
  flex-basis: 80px;
}

.minus,
.add {
  font-size: 15px;
  color: #fff;
  background-color: #ff4f48;
  line-height: 30px;
  width: 35px;
  text-align: center;
  cursor: pointer;
}

.border-color {
  border: 1px solid #26c6da;
  color: #26c6da;
  border-radius: 20px;
  width: 95px;
  line-height: 35px;
  text-align: center;
}

.color-r {
  border: 1px solid #ff4f48;
  color: #ff4f48;
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductBuy.vue